import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="relative w-full bg-primary-800 text-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row gap-10 mb-14">
          <div className="lg:w-[280px]">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-layout-grid-line text-background-50 text-sm"></i>
              </span>
              <span className="text-lg font-bold text-background-50">OOPBUY Spreadsheet</span>
            </div>
            <p className="text-sm text-background-50/50 leading-relaxed mb-4">
              Deine unabhängige Informationsquelle für OOPBUY Spreadsheet in Deutschland. Wir bieten Guides, Kategorien und Trusted Seller Informationen.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line text-sm text-background-50/70"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer" aria-label="Reddit">
                <i className="ri-reddit-line text-sm text-background-50/70"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer" aria-label="Telegram">
                <i className="ri-telegram-line text-sm text-background-50/70"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer" aria-label="YouTube">
                <i className="ri-youtube-line text-sm text-background-50/70"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Kategorien</h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 7).map((cat) => (
                  <li key={cat.id}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200 cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Mehr Kategorien</h4>
              <ul className="space-y-2.5">
                {categories.slice(7).map((cat) => (
                  <li key={cat.id}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200 cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Top Guides</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/artikel/oopbuy-spreadsheet-guide" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200 cursor-pointer">
                    OOPBUY Guide 2026
                  </Link>
                </li>
                <li>
                  <Link to="/artikel/oopbuy-spreadsheet-guide" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200 cursor-pointer">
                    Deutschland Guide
                  </Link>
                </li>
                <li>
                  <Link to="/artikel/oopbuy-spreadsheet-guide" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200 cursor-pointer">
                    QC & Shipping
                  </Link>
                </li>
                <li>
                  <Link to="/artikel/oopbuy-spreadsheet-guide" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200 cursor-pointer">
                    Trusted Sellers
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Rechtliches</h4>
              <ul className="space-y-2.5">
                <li><a href="#" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200 cursor-pointer">Haftungsausschluss</a></li>
                <li><a href="#" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200 cursor-pointer">Datenschutz</a></li>
                <li><a href="#" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200 cursor-pointer">Nutzungsbedingungen</a></li>
                <li><a href="#" className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200 cursor-pointer">Sicherheit</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="text-sm text-background-50/40">© OOPBUY Spreadsheet 2026</span>
            <span className="text-background-50/20">·</span>
            <span className="text-sm text-background-50/40">Alle Rechte vorbehalten.</span>
          </div>
          <div className="flex items-center gap-6">
            <span className="text-sm font-serif italic text-background-50/50">Qualität.</span>
            <span className="text-sm font-serif italic text-background-50/50">Transparenz.</span>
            <span className="text-sm font-serif italic text-background-50/50">Community.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}